import { render, staticRenderFns } from "./ImageButton.vue?vue&type=template&id=55c3edb3&scoped=true&"
import script from "./ImageButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ImageButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ImageButton.vue?vue&type=style&index=0&id=55c3edb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c3edb3",
  null
  
)

export default component.exports